var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intl-about" },
    [
      _c("IntlBreadcrumb"),
      _vm._v(" "),
      _c("div", { staticClass: "intl-about__head" }, [
        _c("h1", { staticClass: "intl-about__title" }, [
          _vm._v(_vm._s(_vm.$t("about.title"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "intl-about__desc" }, [
          _vm._v(_vm._s(_vm.$t("about.desc"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "intl-about__panel" }, [
        _c("div", { staticClass: "intl-about__panel-inner" }, [
          _c("h2", { staticClass: "intl-about__panel-title" }, [
            _vm._v(_vm._s(_vm.$t("about.panelTitle"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "intl-about__panel-text" }, [
            _vm._v(_vm._s(_vm.$t("about.panelDesc"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "intl-about__pillars" }, [
        _c("div", { staticClass: "intl-about__pillar" }, [
          _c(
            "div",
            {
              staticClass: "intl-about__pillar-icon intl-about__pillar-icon--1",
            },
            [_vm._v("🌐")]
          ),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("nav.about")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("about.desc")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "intl-about__pillar" }, [
          _c(
            "div",
            {
              staticClass: "intl-about__pillar-icon intl-about__pillar-icon--2",
            },
            [_vm._v("📚")]
          ),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("nav.courses")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("courses.pageDesc")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "intl-about__pillar" }, [
          _c(
            "div",
            {
              staticClass: "intl-about__pillar-icon intl-about__pillar-icon--3",
            },
            [_vm._v("📰")]
          ),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("nav.news")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("news.pageDesc")))]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "intl-about__entry" },
        [
          _c(
            "router-link",
            {
              staticClass: "intl-about__entry-btn",
              attrs: { to: "/international/courses" },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("home.btnCourse")) + " →\n    ")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "intl-about__entry-btn",
              attrs: { to: "/international/news" },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("home.btnNews")) + " →\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }